import { Typography } from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React from "react";

import ExtendedPageHeader from "../ExtendedPageHeader";
import PreviewPill from "../PreviewPill";
import Skeleton from "../Skeleton";

const useStyles = makeStyles(
  theme => ({
    limit: {
      marginRight: theme.spacing(4)
    },
    preview: {
      position: "absolute",
      top: theme.spacing(-4)
    },
    root: {
      alignItems: "center",
      display: "flex",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
        alignItems: "flex-start",
        "& > *": {
          width: "100%"
        },
        "& > *:not(first-child)": {
          marginTop: theme.spacing(2)
        }
      }
    },
    title: {
      [theme.breakpoints.down("sm")]: {
        fontSize: 20,
        padding: 0
      },
      background:
        "linear-gradient(90deg, #007E92 0%, #009FB8 50.13%, #00B9A3 100%)",
      fontWeight: 700,
      whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent"
    },
    subTitle: {
      fontWeight: 400
    }
  }),
  { name: "PageHeader" }
);

interface PageHeaderProps {
  children?: React.ReactNode;
  className?: string;
  inline?: boolean;
  underline?: boolean;
  limitText?: string;
  title?: React.ReactNode;
  cardMenu?: React.ReactNode;
  preview?: boolean;
  subTitle?: React.ReactNode;
}

const PageHeader: React.FC<PageHeaderProps> = props => {
  const {
    children,
    className,
    inline,
    underline,
    limitText,
    title,
    subTitle,
    cardMenu,
    preview
  } = props;

  const classes = useStyles(props);

  return (
    <>
      {preview && <PreviewPill className={classes.preview} />}
      <ExtendedPageHeader
        testId="page-header"
        className={className}
        inline={inline}
        underline={underline}
        title={
          <>
            <Typography className={classes.title} variant="h3">
              {title !== undefined ? (
                title
              ) : (
                <Skeleton style={{ width: "10em" }} />
              )}{" "}
              {subTitle !== underline ? (
                <span className={classes.subTitle}>{subTitle}</span>
              ) : (
                ""
              )}
            </Typography>
            {cardMenu}
          </>
        }
      >
        <div className={classes.root}>
          {limitText && (
            <Typography className={classes.limit} color="textSecondary">
              {limitText}
            </Typography>
          )}
          {children}
        </div>
      </ExtendedPageHeader>
    </>
  );
};

PageHeader.displayName = "PageHeader";
export default PageHeader;
